/* eslint-disable */
import { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FloatingActionButton } from '@progress/kendo-react-buttons';
import PopUpButton, { INTERNAL_BUTTON, INTERNAL_ITEMS } from '../../components/button';
import FormRow from '../../components/formRow';
import Table from '../../components/table';
import PopUpConfirm from '../../components/popUps/popUpConfirm';
import PopUpError from '../../components/popUps/popUpError';
import { successNotification, warningNotification } from '../../components/notification';
import { getAll, exclude } from '../../services/service';
import LoadScreen from '../load';
import ServiceRegistration from './serviceRegistration';
import './styles.css';

const Services = () => {
  const history = useHistory();
  const [services, setServices] = useState([]);
  const [servicesSelectedsIds, setServicesSelectedsIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popUpConfirmVisibility, setPopUpConfirmVisibility] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [viewMode, setViewMode] = useState('list');
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const onClickInRow = ({ Id }) => history.push(`services/editService/${Id}`);

  const columns = [
    {
      field: 'Codigo',
      title: 'Código',
      columnMenuCheckbox: true
    },
    {
      field: 'Descricao',
      title: 'Descrição',
      columnMenuCheckbox: true
    },
    {
      field: 'CodigoTribNacional',
      title: 'Código Trib. Nacional',
      cell: (props) => {
        const cellClickHandlerProps = {
          onClick: () => onClickInRow(props.dataItem)
        };
        return (
          <td {...cellClickHandlerProps} style={{ textAlign: 'right' }}>
            {props.dataItem.CodigoTribNacional}
          </td>
        );
      },
      columnMenuCheckbox: true
    },
    {
      field: 'Nbs',
      title: 'NBS',
      cell: (props) => {
        const cellClickHandlerProps = {
          onClick: () => onClickInRow(props.dataItem)
        };
        return (
          <td {...cellClickHandlerProps} style={{ textAlign: 'right' }}>
            {props.dataItem.Nbs}
          </td>
        );
      },
      columnMenuCheckbox: true
    },
    {
      field: 'UnidadeMedida',
      title: 'Unidade de Medida',
      cell: (props) => {
        const cellClickHandlerProps = {
          onClick: () => onClickInRow(props.dataItem)
        };
        return (
          <td {...cellClickHandlerProps} style={{ textAlign: 'right' }}>
            {props.dataItem.UnidadeMedida_Nome}
          </td>
        );
      },
      columnMenuCheckbox: true
    },
    {
      field: 'Valor',
      title: 'Valor (R$)',
      isCash: true,
      filter: 'numeric',
      format: '{0:c}',
      columnMenu: true
    }
  ];

  const handleEdit = (id) => {
    setSelectedServiceId(id);
    setViewMode('edit');
  };

  const handleCreate = () => {
    setSelectedServiceId(null);
    setViewMode('edit');
  };

  const handleCancelEdit = () => {
    setViewMode('list');
    setSelectedServiceId(null);
  };

  const handleSaveSuccess = async () => {
    await fetchServices();
    setViewMode('list');
    setSelectedServiceId(null);
  };

  const fetchServices = useCallback(async () => {
    setLoading(true);
    const { data } = await getAll();
    setServices(data);
    setLoading(false);
  }, []);

  useEffect(async () => {
    await fetchServices();
  }, []);

  const excludeServices = async () => {
    const excludeServicesRequests = servicesSelectedsIds.map((serviceSelected) =>
      exclude(serviceSelected)
    );

    const excludeServicesResponses = await Promise.all(excludeServicesRequests);

    const isAllRequestsRight = excludeServicesResponses.reduce(
      (acc, currentResponse) => acc && currentResponse.status === 200,
      true
    );

    if (isAllRequestsRight) successNotification('Serviço(s) excluído(s) com sucesso!');
    else {
      const erro = ['Houve um erro ao tentar excluir um ou mais serviços:'];
      excludeServicesResponses.forEach((element) => {
        const { data } = element;
        erro.push(data.MensagemUsuario);
      });
      setPopUpErrorMessage(erro);
      setPopUpError(true);
    }

    setServicesSelectedsIds([]);
    await fetchServices();
  };

  return loading ? (
    <LoadScreen />
  ) : viewMode === 'edit' ? (
    <ServiceRegistration
      serviceId={selectedServiceId}
      onCancel={handleCancelEdit}
      onSave={handleSaveSuccess}
    />
  ) : (
    <>
      <div id="service-list">
        <h1>Serviços</h1>

        <FormRow justifyEnd withoutMarginTop space10>
          <div className="config-components-popup-button">
            <FloatingActionButton icon={INTERNAL_BUTTON.BUTTON_ADD} onClick={handleCreate} />
          </div>
          <PopUpButton
            internalButton={INTERNAL_BUTTON.BUTTON_THREEPOINTS}
            internalItems={[
              {
                id: INTERNAL_ITEMS.EXCLUIR,
                onClick: () => {
                  if (servicesSelectedsIds.length > 0) setPopUpConfirmVisibility(true);
                  else warningNotification('Nenhum serviço selecionado');
                },
                text: 'Excluir serviços'
              }
            ]}
          />
        </FormRow>

        <Table
          name="Services"
          data={services}
          columns={columns}
          dataItemKey="Id"
          haveCheckbox
          setItemKeysSelected={setServicesSelectedsIds}
          style={{ minHeight: 500, marginTop: 20, height: '100%' }}
          onClickInRow={({ Id }) => handleEdit(Id)}
          sortable={true}
        />
      </div>
      <PopUpConfirm
        onConfirm={excludeServices}
        visible={popUpConfirmVisibility}
        setVisible={setPopUpConfirmVisibility}
        title="Confirmação"
        message="Você tem certeza que deseja excluir o(s) serviço(s) selecionado(s)?"
      />
      <PopUpError
        visible={popUpError}
        setVisible={setPopUpError}
        title="Erro ao excluir um serviço"
        message={popUpErrorMessage}
      />
    </>
  );
};

export default Services;
